import { render } from "./rewardPoints.vue?vue&type=template&id=28a1cd48&scoped=true"
import script from "./rewardPoints.vue?vue&type=script&lang=js"
export * from "./rewardPoints.vue?vue&type=script&lang=js"

import "./rewardPoints.vue?vue&type=style&index=0&id=28a1cd48&lang=scss&scoped=true"
import "./rewardPoints.vue?vue&type=style&index=1&id=28a1cd48&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a1cd48"]])

export default __exports__